import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px 24px 0 24px;
  border: none;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${grey};
    border-radius: 1px;
  }
`;

export const DotsBar = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;
